export default __webpack_public_path__ + "src/assets/icn-key-mnemonic.fbbd432364daa7dc7589e9483d01cff4.svg";